'use strict';

const selectors = {
    siteHeader: '.page-header',
    scrollArea: '.js-bscan-step.bscan-advice .bscan-step-scroll-area'
};

/**
 * @public scrollTo
 * @param {Object} data - The optional object containing the top & left positions to scroll to
 */
function scrollTo(data) {
    const position = data || {
        top: 0,
        left: 0
    };
    const positionTop = parseInt(position.top, 10);
    const positionLeft = parseInt(position.left, 10);

    const scrollArea = document.querySelector(selectors.scrollArea);
    const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    if (scrollArea) {
        if (supportsNativeSmoothScroll) {
            scrollArea.scrollTo({
                top: positionTop,
                left: positionLeft,
                behavior: 'smooth'
            });
        } else {
            scrollArea.scrollTop = positionTop;
        }
    } else {
        const stickyHeader = document.querySelector(selectors.siteHeader);
        const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

        document.documentElement.scrollTop = positionTop - headerHeight - 15; // Removing an additional 15px to put some space between the sticky site header and the element
        document.body.scrollTop = positionTop - headerHeight - 15; // Removing an additional 15px to put some space between the sticky site header and the element
    }
}

export { scrollTo };
